import { Alert, IconButton, Stack, Typography } from "@mui/material"
import { GroupStatus } from "../../../lib/enum/group-status.mjs"
import { DialogBox } from "lib/@components/dialogBox"
import { ErrorDialogItem } from "./error-dialog-item"
import { Bound } from "lib/@components/binding/Bound"
import Iconify from "minimals-template/components/Iconify"
import { Frag } from "lib/@components/slot/frag"
import { useOkCancelContext } from "lib/@hooks/useOkCancelContext"
import { PagedRepeat } from "lib/@components/paged-repeat"
import { If } from "lib/@components/switch"
import { getProjectScopedSchedules } from "authoring/routes/project/controller/get-project-scoped-schedules"
import { useParams } from "react-router"

export function ErrorDetailsDialog({ group }) {
    const { projectId } = useParams()
    const legacySendResults = group.legacySendResults ?? []

    const { data: allSchedules, loading: schedulesLoading } = getProjectScopedSchedules.useResults.status({
        projectId,
    })
    const failCount = legacySendResults.filter(({ status }) => status === GroupStatus.FAILED).length
    const sortedResults = [...legacySendResults].sort((a, b) => {
        if (a.status === b.status) return 0
        if (a.status === GroupStatus.FAILED) return -1
        return 1
    })
    const okCancel = useOkCancelContext()

    const { cancel } = okCancel
    const lookup = allSchedules?.keyBy("id")

    return (
        <Bound scheduleLookup={lookup} schedulesLoading={schedulesLoading}>
            <DialogBox
                data-cy="error-details-dialog"
                Actions={Frag}
                title={
                    <Stack>
                        <Typography variant="h5" data-cy="error-details-dialog-title">
                            {group.name}
                        </Typography>
                        <Typography data-cy="error-details-dialog-subtitle">{failCount} failed</Typography>
                    </Stack>
                }
            >
                <IconButton
                    aria-label="close"
                    onClick={cancel}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <Iconify icon="material-symbols:close-rounded" />
                </IconButton>
                <If truthy={group.error}>
                    <Alert
                        severity="error"
                        sx={{ mb: 2, width: "100%" }}
                        data-cy="error-details-banner"
                        variant="outlined"
                    >
                        {group.error}
                    </Alert>
                </If>
                <PagedRepeat list={sortedResults} item={<ErrorDialogItem />} />
            </DialogBox>
        </Bound>
    )
}
